<template>
  <section class="resolution__statuses">
    <div class="container-fluid">
      <div class="resolution__statuses__wrapper">
        <div class="resolution__status__left">
          <ul class="resolution__status nav">
            <li v-for="(stage, index) in stages" :key="index"
                class="resolution__status__item mr-1 last:mr-0 status__stage"
                :class="{'cursor-pointer': isStatusStageActive(index), 'orange__medium': isStatusInProgress(index), 'green__lighter': isStatusCompleted(index)}">
              {{ stage.label }}
              <div v-if="isStatusStageActive(index)" class="status__popover">
                <span class="status__popover__title">{{ $lang.$translate({ru: application.status.nameRu, kg: application.status.nameKg}) }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="resolution__status__right">
          <span class="resolution__doc__status orange__medium">{{ application.paymentStatusTxt }}</span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    application: Object
  },
  data() {
    return {
      stages: [
        {
          label: this.$lang.app.APPLICATION_ACCEPTED,
          statuses: [2,3,4],
          specialStatuses: [4],
        },
        {
          label: this.$lang.app.AGREEMENT,
          statuses: [5,7,8,21,27],
          specialStatuses: [],
        },
        {
          label: this.$lang.app.EXPERTIZE,
          statuses: [9,10,22,24,25,26],
          specialStatuses: [],
        },
        {
          label: this.$lang.app.COMPLETION,
          statuses: [23,28],
          specialStatuses: [23]
        }
      ]
    }
  },
  computed: {
    activeStageIndex() {
      return this.stages.findIndex(stage => stage.statuses.some(status => status == this.application.status.id))
    },
    isActiveStageSpecialStatus() {
      return this.stages[this.activeStageIndex].specialStatuses.some(specialStatus => specialStatus == this.application.status.id)
    }
  },
  methods: {
    isStatusStageActive(index) {
      return index == this.activeStageIndex
    },
    isStatusInProgress(index) {
      return (this.isStatusStageActive(index) && !this.isActiveStageSpecialStatus) || (this.isStatusStageActive(index - 1) && this.isActiveStageSpecialStatus)
    },
    isStatusCompleted(index) {
      return index < this.activeStageIndex || (index == this.activeStageIndex && this.isActiveStageSpecialStatus)
    }
  }
}
</script>
<style>
.status__stage:hover .status__popover {
  opacity: 1;
  transform: translateY(0);
  visibility: visible;
}
</style>
